import { I18n } from '@calendly/i18n';
import { Body, Cell, Header, HeaderCell, Row, Table } from '@calendly/table';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { VisuallyHidden } from '@calendly/ui/components/visually-hidden';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1xq3e0t";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const SelectedGroups = ({
  suggestions,
  onRemove
}) => {
  if (suggestions.length === 0) return null;
  return <Container>
      <Table noContainerBorder>
        <Header>
          <HeaderCell>
            {I18n.t('publisher.organization.managed_event_types.assign.add_groups.group_name')}
          </HeaderCell>
          <HeaderCell>
            {I18n.t('publisher.organization.managed_event_types.assign.add_groups.group_members')}
          </HeaderCell>
          <HeaderCell hugContent>
            <VisuallyHidden>
              {I18n.t('publisher.event_types.members.remove')}
            </VisuallyHidden>
          </HeaderCell>
        </Header>
        <Body>
          {suggestions.map(suggestion => <Row key={suggestion.id}>
              <Cell label={I18n.t('publisher.organization.managed_event_types.assign.add_groups.group_name')}>
                {suggestion.entity.name}
              </Cell>
              <Cell label={I18n.t('publisher.organization.managed_event_types.assign.add_groups.group_members')}>
                {I18n.t('publisher.organization.managed_event_types.assign.add_groups.group_members_count', {
              count: suggestion.entity.user_group_relationships_count
            })}
              </Cell>
              <Cell hasActions>
                <IconButton size="small" title={I18n.t('publisher.action.remove')} onClick={() => onRemove(suggestion)}>
                  <CloseIcon />
                </IconButton>
              </Cell>
            </Row>)}
        </Body>
      </Table>
    </Container>;
};

require("./selected_groups.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./selected_groups.js");